"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const frontpage_1 = require("./themes/frontpage");
exports.default = (presentation) => {
    const theme = presentation.theme || {};
    return {
        name: presentation.name,
        values: presentation.application_vars,
        createdAt: presentation.created_at,
        updatedAt: presentation.updated_at,
        applicationId: presentation.application_id,
        applicationDeploymentId: presentation.application_deployment_id,
        applicationName: presentation.application_name,
        theme: {
            name: theme.name || frontpage_1.default.name,
            backgroundColor: theme.background_color || frontpage_1.default.background_color,
            bodyFont: theme.body_font || frontpage_1.default.body_font,
            bodyTextColor: theme.body_text_color || frontpage_1.default.body_text_color,
            headingFont: theme.heading_font || frontpage_1.default.heading_font,
            headingTextColor: theme.heading_text_color || frontpage_1.default.heading_text_color,
            // These are optional fields and should not default to front page to allow
            // apps to handle the default values if not set.
            backgroundImage: theme.background_image,
            backgroundImagePortrait: theme.background_image_portrait,
            heading2Font: theme.heading_2_font,
            heading2TextColor: theme.heading_2_text_color,
            borderColor: theme.border_color,
        },
    };
};
//# sourceMappingURL=mapPresentationToProps.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/mapPresentationToProps.js